import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import { RelatedSearchTypes } from '../../../types';
import { fetchRelatedSearchTerms } from '../../../service/relatedSearchTerms';
import SearchTags from './SearchTags';
import './index.scss';

const RelatedSearch = ({ displayData }) => {

    const [relatedTerms, setRelatedTerms] = useState([]);

    useEffect(() => {
        const initData = async() => {
            const { searchComponentData: { relatedTermsUrl } } = displayData;
            const relatedTerms = await fetchRelatedSearchTerms(relatedTermsUrl);
            setRelatedTerms(relatedTerms);
        };

        initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { isTouch } = getContext();
    const hasSearchTags = relatedTerms.length !== 0;

    return (
        <header className="related-search">
            <nav className={classNames('layout-row', { 'scrollable-related-links': isTouch })}>
                {hasSearchTags &&
                <React.Fragment>
                    {!isTouch && <b><I18n k="search_perseus.related_search.suggested"/></b>}
                    <SearchTags relatedTerms={relatedTerms}/>
                </React.Fragment>
                }
            </nav>
        </header>
    );
};

RelatedSearch.propTypes = RelatedSearchTypes;

export default RelatedSearch;
